module.exports = __webpack_public_path__ + "img/album09_03.9879f6c6.jpg";